import OpenStreetMap from '../modules/components/OpenStreetMap';
export default class PlacesToVisitPage {
    constructor() {
        this.page = document.querySelector('.post-type-archive-places-to-visit');
        if (this.page) {
            this.initOpenStreetMap();
        }
        else {
            this.taxonomyPage = document.querySelector('.tax-places-to-visit-category');
            if (this.taxonomyPage) {
                this.initOpenStreetMap();
            }
        }
    }
    initOpenStreetMap() {
        const mapContainer = document.getElementById('places-map');
        // if no map container
        if (!mapContainer)
            return;
        const postsData = mapContainer.dataset.posts;
        // if no posts data
        if (!postsData)
            return;
        const posts = JSON.parse(postsData);
        new OpenStreetMap('places-map', posts);
    }
}
